import FormFields from "constants/formFields";
import { getPrePaymentFormFieldsForEntity } from "helpers/getFormFieldsForEntity";
import useEntityStore from "store/entityStore";
import fieldRepository from "./field-repository";

export default function getFormConfig(config) {
  const entity = useEntityStore.getState().entity;
  const baseFields = getPrePaymentFormFieldsForEntity(entity);

  let baseFieldOrder = baseFields?.filter(key => fieldRepository.hasOwnProperty(key)) || [];
  let configFieldOrder = config?.order?.filter(key => fieldRepository.hasOwnProperty(key)) || [];

  const fieldsSet = new Set([...FormFields.prePaymentForm.default, ...baseFieldOrder, ...configFieldOrder]); // Used set to remove duplicates as entity and config might request same field twice, order in set is stable
  const fieldsOrderArray = [...fieldsSet];

  const formConfig = {
    title: 'Fill your details',
    description: 'It is mandatory to fill this form to ensure that the service is provided only to the verified users',
    show_secured_banner: true,
    order: fieldsOrderArray, // This will dictate the fields being shown.
    fields: fieldRepository
  };

  return formConfig;
}